import React, { useState, useCallback } from 'react';
import { Switch, Text, View } from 'react-native';
import { Image } from 'expo-image';
import { TextInput } from 'react-native-gesture-handler';
import DatePicker from 'react-native-date-picker';
import DropDownPicker from 'react-native-dropdown-picker';
import Slider from '@react-native-community/slider';
import Checkbox from 'expo-checkbox';
import styles from '@stylesheet';

interface DynamicComponent {
  componentType: string;
  defaultValue?: any;
  parameters?: object;
}

const ExamplePreviewHandler = React.memo(({ componentType, defaultValue, parameters }: DynamicComponent) => {
  const [pickerValue, setPickerValue] = useState(defaultValue);
  const [checked, setChecked] = useState(defaultValue === 'checked');
  const [checked2, setChecked2] = useState(defaultValue || false);
  const [date, setDate] = useState(new Date());
  const [open, setOpen] = useState(false);


  // Memoized event handlers
  const handleCheckboxChange = useCallback((newValue) => setPickerValue(newValue), []);
  const handleSwitchChange = useCallback((newValue) => setPickerValue(newValue), []);
  const handleSliderChange = useCallback((newValue) => setPickerValue(newValue), []);

  const HandleReturnedComponent = () => {
    switch (componentType) {
      case 'string':
        return (
          <TextInput value={defaultValue} style={{ backgroundColor: 'white', borderRadius: 20, padding: 10, marginVertical: 10 }} />
        );
      case 'boolean':
      case 'boolean':
        return (
          <View style={{ flexDirection: 'row', gap: 20 }}>
            <View style={{ backgroundColor: 'white', borderRadius: 10, padding: 10, alignItems: 'center' }}>
              <View style={{ 
                width: 20, 
                height: 20, 
                borderRadius: 10, 
                backgroundColor: checked ? '#007AFF' : 'transparent', 
                borderWidth: 2, 
                borderColor: '#007AFF' 
              }} />
              <Text>True</Text>
            </View>
            <View style={{ backgroundColor: 'white', borderRadius: 10, padding: 10, alignItems: 'center' }}>
              <View style={{ 
                width: 20, 
                height: 20, 
                borderRadius: 10, 
                backgroundColor: checked2 ? '#007AFF' : 'transparent', 
                borderWidth: 2, 
                borderColor: '#007AFF' 
              }} />
              <Text>False</Text>
            </View>
          </View>
        );
        return (
          <DatePicker minimumDate={new Date()} date={date} textColor="black" mode="date" />
        );
      case 'dropdown':
        return (
          <DropDownPicker
            zIndex={3}
            dropDownContainerStyle={{ bottom: 70, borderColor: '#4791bd' }}
            value={pickerValue}
            setValue={setPickerValue}
            dropDownDirection="TOP"
            style={{ marginVertical: 20, minWidth:"100%", borderColor: '#4791bd' }}
            open={open}
            setOpen={setOpen}
            items={[{ value: 'sample 1', label: 'First Example' }]}
          />
        );
      case 'image':
        return (
          <View style={{ flexDirection: 'row' }}>
            <Image source={require('@assets/images/1x/default-placeholder.png')} style={{ height: 50, width: 50, margin: 10 }} />
            <Text style={{ fontSize: 10, maxWidth: 200, margin: 10, left: -10 }} numberOfLines={2}>
              Using this, you can upload your own image
            </Text>
          </View>
        );
      case 'switch':
        return (
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Switch value={defaultValue} onValueChange={handleSwitchChange} />
            <Text>{defaultValue ? 'On' : 'Off'}</Text>
          </View>
        );
      case 'slider':
        return (
          <View>
            <Slider
              value={defaultValue}
              onValueChange={handleSliderChange}
              minimumValue={0}
              maximumValue={100}
            />
            <Text>{defaultValue}</Text>
          </View>
        );
      case 'checkbox':
        return (
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Checkbox value={defaultValue} onValueChange={handleCheckboxChange} />
            <Text>{defaultValue}</Text>
          </View>
        );
      case 'textarea':
        return (
          <TextInput
            value={defaultValue}
            style={{ backgroundColor: 'white', borderRadius: 20, padding: 10, marginVertical: 10, height: 100 }}
            multiline
          />
        );
      case 'file':
        // Handle file upload component (customize as needed)
        return <Text>File Upload Component</Text>;
      default:
        return null; // Add default case to handle unknown component types
    }
  };

  return <View style={[styles.centerEverything, { flex: 1, minHeight: 100 }]}>
    {HandleReturnedComponent()}
    </View>;
});

export default ExamplePreviewHandler;
